import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination } from "@mui/material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import React, { useEffect, useState } from "react";

function Promo() {
    const [load, setLoad] = useState(true);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));

    // State điều khiển Modal
    const [isCreateOpen, setCreateOpen] = useState(false);
    const [isEditOpen, setEditOpen] = useState(false);
    const [selectedPromo, setSelectedPromo] = useState(null);

    // State Tìm kiếm
    const [searchCode, setSearchCode] = useState("");

    // State Phân trang
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10;

    const [promoList, setPromoList] = useState([]);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Lấy danh sách Khuyến mãi từ Backend
    const fetchPromos = () => {
        setLoad(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/promo/get?page=${page}&limit=${limit}`)
            .then((res) => {
                if (res.data.success) {
                    setPromoList(res.data.data || []);
                    setTotalPages(res.data.totalPages || 1);
                }
                setLoad(false);
            })
            .catch(() => setLoad(false));
    };

    useEffect(() => {
        fetchPromos();
    }, [page]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Thêm Giftcode Mới
    const handleCreateSubmit = (e) => {
        e.preventDefault();
        setLoad(true);

        const money = Number(e.target.money.value || 0) * 1000;
        const wager = Number(e.target.wager.value) || 1;
        const type_code = e.target.type_code.value || "Tất cả";
        const num = Number(e.target.num.value);
        const expired_at = e.target.expired_at.value || "Không giới hạn";
        const customCode = e.target.code ? e.target.code.value.trim() : "";

        const formData = {
            code: customCode || "GC" + Math.floor(10000000 + Math.random() * 90000000),
            money: money,
            wager: wager,
            type_code: type_code,
            num: num,
            expired_at: expired_at
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/promo/create`, formData)
            .then((res) => {
                if (res.data.success) {
                    swal(t("success"), "Tạo giftcode thành công", "success").then(() => {
                        setCreateOpen(false);
                        setPage(1);
                        fetchPromos();
                    });
                } else {
                    swal(t("error"), res.data.message || "Không thể tạo giftcode", "error");
                    setLoad(false);
                }
            })
            .catch(() => {
                swal(t("error"), "Có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    // Sửa Giftcode
    const handleEditSubmit = (e) => {
        e.preventDefault();
        setLoad(true);

        const formData = {
            id: selectedPromo._id,
            code: e.target.code.value,
            money: Number(e.target.money.value || 0) * 1000,
            wager: Number(e.target.wager.value) || 1,
            type_code: e.target.type_code.value || "Tất cả",
            num: Number(e.target.num.value),
            expired_at: e.target.expired_at.value || "Không giới hạn"
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/promo/edit`, formData)
            .then((res) => {
                if (res.data.success) {
                    swal(t("success"), "Cập nhật thành công", "success").then(() => {
                        setEditOpen(false);
                        fetchPromos();
                    });
                } else {
                    swal(t("error"), res.data.message || "Thất bại", "error");
                    setLoad(false);
                }
            })
            .catch(() => {
                swal(t("error"), "Có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    // Xóa Giftcode
    const handleDelete = (item) => {
        swal({
            title: "Bạn có chắc chắn?",
            text: "Xóa mã này sẽ không thể khôi phục!",
            icon: "warning",
            buttons: ["Hủy bỏ", "Xóa"],
            dangerMode: true
        }).then((willDelete) => {
            if (willDelete) {
                setLoad(true);
                axios
                    .post(`${process.env.REACT_APP_API_URL}/promo/delete`, { id: item._id })
                    .then((res) => {
                        if (res.data && res.data.success !== false) {
                            swal(t("success"), "Đã xóa giftcode thành công!", "success");
                            fetchPromos();
                        } else {
                            swal(t("error"), res.data?.message || "Xóa thất bại", "error");
                            setLoad(false);
                        }
                    })
                    .catch((err) => {
                        swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra khi xóa", "error");
                        setLoad(false);
                    });
            }
        });
    };

    // Lọc theo từ khóa tìm kiếm
    const filteredPromos = promoList
        ? promoList.filter((item) =>
              item.code?.toLowerCase().includes(searchCode.toLowerCase().trim())
          )
        : [];

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                {profile?.permission?.full === 1 || profile?.isReadOnly || profile?.permission?.readonly == 1 ? (
                    <Box component="main" sx={{ flexGrow: 1, py: 4, px: 3, position: "relative" }}>
                        {load && (
                            <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                                <div className="loader"></div>
                            </div>
                        )}

                        {/* Nút Hướng dẫn góc trên bên phải */}
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                            <button
                                type="button"
                                style={{
                                    background: "#fff",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "16px",
                                    padding: "4px 14px",
                                    fontSize: "13px",
                                    color: "#555",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px"
                                }}
                            >
                                Hướng dẫn{" "}
                                <span
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "50%",
                                        border: "1px solid #666",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "11px",
                                        lineHeight: 1
                                    }}
                                >
                                    ?
                                </span>
                            </button>
                        </div>

                        {/* THANH TÌM KIẾM VÀ THÊM MỚI (Matching Image 2) */}
                        <div
                            style={{
                                background: "#fff",
                                padding: "20px 24px",
                                borderRadius: "8px",
                                marginBottom: "24px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                            }}
                        >
                            <div style={{ fontSize: "13px", color: "#333", fontWeight: 500, marginBottom: "8px" }}>
                                Mã code
                            </div>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <input
                                    type="text"
                                    placeholder=""
                                    value={searchCode}
                                    onChange={(e) => setSearchCode(e.target.value)}
                                    style={{
                                        width: "320px",
                                        height: "38px",
                                        padding: "0 12px",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "6px",
                                        outline: "none",
                                        fontSize: "14px"
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => fetchPromos()}
                                    style={{
                                        background: "#1890ff",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "0 20px",
                                        height: "38px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        cursor: "pointer"
                                    }}
                                >
                                    Tìm kiếm
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setCreateOpen(true)}
                                    style={{
                                        background: "#22c55e",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "0 20px",
                                        height: "38px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        cursor: "pointer"
                                    }}
                                >
                                    Thêm mới
                                </button>
                            </div>
                        </div>

                        {/* BẢNG DANH SÁCH GIFTCODE (Matching Image 2 Table) */}
                        <div
                            style={{
                                background: "#fff",
                                borderRadius: "8px",
                                overflow: "hidden",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                            }}
                        >
                            <Table sx={{ width: "100%" }}>
                                <TableHead sx={{ backgroundColor: "#FAFADA" }}>
                                    <TableRow sx={{ backgroundColor: "#fafafa" }}>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Mã code
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Số điểm
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Vòng cược
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Loại mã
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Danh sách khách hàng
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Thời hạn nhận
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2 }}>
                                            Tác vụ
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredPromos && filteredPromos.length > 0 ? (
                                        filteredPromos.map((item) => (
                                            <TableRow key={item._id} sx={{ "&:hover": { backgroundColor: "#fafafa" } }}>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {item.code}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {Math.floor((item.money || 0) / 1000).toLocaleString("vi-VN")} điểm
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {item.wager || 1}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {item.type_code || "Tất cả"}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {item.customer_list || "Tất cả"}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    {item.expired_at || "Không giới hạn"}
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: "1px solid #f0f0f0", py: 1.8 }}>
                                                    <span
                                                        onClick={() => {
                                                            setSelectedPromo(item);
                                                            setEditOpen(true);
                                                        }}
                                                        style={{ color: "#1890ff", cursor: "pointer", marginRight: "16px", fontWeight: "500", fontSize: "14px" }}
                                                    >
                                                        Sửa
                                                    </span>
                                                    <span
                                                        onClick={() => handleDelete(item)}
                                                        style={{ color: "#ff4d4f", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}
                                                    >
                                                        Xóa
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} style={{ textAlign: "center", padding: "60px 0", borderBottom: "none" }}>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M52 20L32 10L12 20V44L32 54L52 44V20Z" stroke="#E5E7EB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12 20L32 30L52 20" stroke="#E5E7EB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M32 30V54" stroke="#E5E7EB" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                    <div style={{ marginTop: "12px", color: "#9CA3AF", fontSize: "14px" }}>Trống</div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        {/* THANH PHÂN TRANG */}
                        {totalPages > 1 && (
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3, pb: 3 }}>
                                <Pagination color="primary" count={totalPages} page={page} onChange={handleChangePage} />
                            </Box>
                        )}

                        {/* MODAL TẠO GIFTCODE (Matching Image 3) */}
                        {isCreateOpen && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                                    zIndex: 1000,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        width: "540px",
                                        maxWidth: "92vw",
                                        padding: "24px",
                                        position: "relative",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                                    }}
                                >
                                    {/* Nút đóng ✕ */}
                                    <button
                                        onClick={() => setCreateOpen(false)}
                                        style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "16px",
                                            background: "none",
                                            border: "none",
                                            fontSize: "18px",
                                            color: "#999",
                                            cursor: "pointer"
                                        }}
                                    >
                                        ✕
                                    </button>

                                    {/* Tiêu đề Modal */}
                                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", textAlign: "center", marginBottom: "24px" }}>
                                        Tạo giftcode
                                    </div>

                                    <form onSubmit={handleCreateSubmit}>
                                        {/* Hàng 1: Số điểm | Vòng cược */}
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Số điểm
                                                </label>
                                                <input
                                                    type="number"
                                                    name="money"
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Vòng cược
                                                </label>
                                                <input
                                                    type="number"
                                                    name="wager"
                                                    defaultValue={1}
                                                    required
                                                    placeholder="Vòng cược"
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Hàng 2: Loại mã */}
                                        <div style={{ marginBottom: "16px" }}>
                                            <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                Loại mã
                                            </label>
                                            <select
                                                name="type_code"
                                                defaultValue="Tất cả"
                                                style={{
                                                    width: "100%",
                                                    height: "38px",
                                                    padding: "0 12px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #d9d9d9",
                                                    outline: "none",
                                                    fontSize: "14px",
                                                    background: "#fff"
                                                }}
                                            >
                                                <option value="Tất cả">Tất cả</option>
                                            </select>
                                        </div>

                                        {/* Hàng 3: Số lượng nhận | Thời hạn nhận */}
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Số lượng nhận
                                                </label>
                                                <input
                                                    type="number"
                                                    name="num"
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Thời hạn nhận
                                                </label>
                                                <input
                                                    type="text"
                                                    name="expired_at"
                                                    placeholder="Chọn thời điểm"
                                                    onFocus={(e) => (e.target.type = "datetime-local")}
                                                    onBlur={(e) => {
                                                        if (!e.target.value) e.target.type = "text";
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Mã code tùy chọn */}
                                        <div style={{ marginBottom: "20px" }}>
                                            <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                Mã code (Tùy chọn - Tự động tạo nếu bỏ trống)
                                            </label>
                                            <input
                                                type="text"
                                                name="code"
                                                placeholder="Mã code"
                                                style={{
                                                    width: "100%",
                                                    height: "38px",
                                                    padding: "0 12px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #d9d9d9",
                                                    outline: "none",
                                                    fontSize: "14px"
                                                }}
                                            />
                                        </div>

                                        {/* Nút hành động Modal */}
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px" }}>
                                            <button
                                                type="button"
                                                onClick={() => setCreateOpen(false)}
                                                style={{
                                                    background: "#fff",
                                                    border: "1px solid #d9d9d9",
                                                    borderRadius: "6px",
                                                    padding: "7px 20px",
                                                    fontSize: "14px",
                                                    color: "#555",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Hủy bỏ
                                            </button>
                                            <button
                                                type="submit"
                                                style={{
                                                    background: "#d9534f",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    padding: "7px 24px",
                                                    fontSize: "14px",
                                                    color: "#fff",
                                                    fontWeight: 500,
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Tạo
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}

                        {/* MODAL SỬA GIFTCODE */}
                        {isEditOpen && selectedPromo && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                                    zIndex: 1000,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        width: "540px",
                                        maxWidth: "92vw",
                                        padding: "24px",
                                        position: "relative",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                                    }}
                                >
                                    <button
                                        onClick={() => setEditOpen(false)}
                                        style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "16px",
                                            background: "none",
                                            border: "none",
                                            fontSize: "18px",
                                            color: "#999",
                                            cursor: "pointer"
                                        }}
                                    >
                                        ✕
                                    </button>

                                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", textAlign: "center", marginBottom: "24px" }}>
                                        Chỉnh sửa giftcode - {selectedPromo.code}
                                    </div>

                                    <form onSubmit={handleEditSubmit}>
                                        <div style={{ marginBottom: "16px" }}>
                                            <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                Mã code
                                            </label>
                                            <input
                                                type="text"
                                                name="code"
                                                defaultValue={selectedPromo.code}
                                                required
                                                style={{
                                                    width: "100%",
                                                    height: "38px",
                                                    padding: "0 12px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #d9d9d9",
                                                    outline: "none",
                                                    fontSize: "14px"
                                                }}
                                            />
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Số điểm
                                                </label>
                                                <input
                                                    type="number"
                                                    name="money"
                                                    defaultValue={Math.floor((selectedPromo.money || 0) / 1000)}
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Vòng cược
                                                </label>
                                                <input
                                                    type="number"
                                                    name="wager"
                                                    defaultValue={selectedPromo.wager || 1}
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ marginBottom: "16px" }}>
                                            <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                Loại mã
                                            </label>
                                            <select
                                                name="type_code"
                                                defaultValue={selectedPromo.type_code || "Tất cả"}
                                                style={{
                                                    width: "100%",
                                                    height: "38px",
                                                    padding: "0 12px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #d9d9d9",
                                                    outline: "none",
                                                    fontSize: "14px",
                                                    background: "#fff"
                                                }}
                                            >
                                                <option value="Tất cả">Tất cả</option>
                                            </select>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Số lượng nhận
                                                </label>
                                                <input
                                                    type="number"
                                                    name="num"
                                                    defaultValue={selectedPromo.num}
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Thời hạn nhận
                                                </label>
                                                <input
                                                    type="text"
                                                    name="expired_at"
                                                    defaultValue={selectedPromo.expired_at || "Không giới hạn"}
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px" }}>
                                            <button
                                                type="button"
                                                onClick={() => setEditOpen(false)}
                                                style={{
                                                    background: "#fff",
                                                    border: "1px solid #d9d9d9",
                                                    borderRadius: "6px",
                                                    padding: "7px 20px",
                                                    fontSize: "14px",
                                                    color: "#555",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Hủy bỏ
                                            </button>
                                            <button
                                                type="submit"
                                                style={{
                                                    background: "#1890ff",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    padding: "7px 24px",
                                                    fontSize: "14px",
                                                    color: "#fff",
                                                    fontWeight: 500,
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Cập nhật
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                    </Box>
                ) : (
                    <Box sx={{ p: 3 }}>{t("not_permission")}</Box>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Promo;
